import React from "react";
import { useNavigate } from "react-router-dom";
import PageHero from "@/components/PageHero";
import Admissions from "@/components/Admissions";
import { HERO_IMAGES } from "@/data/heroImages";
import { ArrowRight } from "lucide-react";

export default function AdmissionsPage() {
  const navigate = useNavigate();

  return (
    <>
      <div className="pt-20">
        <Admissions />
      </div>
      <PageHero
        eyebrow="Admission"
        title="Rejoignez la révolution des"
        italicWord="compétences !"
        subtitle="Notre processus d'admission repose sur trois étapes, un engagement de réponse sous 48 heures et une transparence totale. Votre dossier n'attend pas, si votre candidature est acceptée, votre place est réservée immédiatement pour la rentrée. Postulez dès maintenant pour sécuriser votre rentrée."
        crumb="Admission"
        image={HERO_IMAGES.admissions}
        cta={
          <button onClick={() => navigate("/contact#candidater")} className="btn-red">
            Candidater
            <ArrowRight className="h-4 w-4" />
          </button>
        }
      />
    </>
  );
}
